const CUSTOM_CAKE_IDS = {
  SIZE_GROUP_ID: 37,
  SHAPE_GROUP_ID: 32,
  FLAVOR_GROUP_ID: 31,
  D3_GROUP_ID: 38,
  GLITTER_GROUP_ID: 39,
  RIBBON_GROUP_ID: 40,
  MESSAGE_GROUP_ID: 41,
  SIZE_5INCH_ID: 99,
  SIZE_6INCH_ID: 100,
  SIZE_8INCH_ID: 101,
  SHAPE_ROUND_ID: 85,
  FLAVOR_CHOCOLATE_ID: 81,
  FLAVOR_STRAWBERRY_ID: 82,
  D3_0SHAPE_ID: 102,
  D3_1SHAPE_ID: 108,
  D3_2SHAPE_ID: 109,
  D3_3SHAPE_ID: 110,
  GLITTER_GOLDEN_ID: 105,
  GLITTER_SILVER_ID: 111,
  RIBBON_NO_ID: 104,
  RIBBON_1PC_ID: 106,
  RIBBON_2PC_ID: 112,
  RIBBON_3PC_ID: 113,
  RIBBON_4PC_ID: 114,
  MESSAGE_PRINTING_ID: 115,
};

export default CUSTOM_CAKE_IDS;